<template>
  <div>
    <div class="login">
      <div class="main">
        <img src='../assets/images/common/loading.gif' alt="" width="150" class="animate__animated animate__bounceOut">
        <div class="text animate__animated animate__bounceOut">Loading...</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { browserUrl } from '@/utils/index.js'
import { ElMessage } from 'element-plus'
// import { useRouter } from 'vue-router'
// import { browserUrl } from '@/utils/index.js'
// import { loginOut } from '@/api/login'
export default {
  setup(props, context) {
    // const instance = getCurrentInstance()
    const { appContext } = getCurrentInstance()
    const global = appContext.config.globalProperties;
    // const store = appContext.config.globalProperties.$store;
    // console.log(appContext.config)
    // console.log(proxy)
    console.log(context)
    // console.log(appContext.config.globalProperties.$router)
    // console.log(proxy.$root.$router)
    // console.log(proxy.$root.$route)
    console.log(global)
    onMounted(() => {
      let userInfo = {
        yhid: Number(global.$route.query.yhid),
        zhid: Number(global.$route.query.zhid),
        realname: global.$route.query.realname,
        jsmc: global.$route.query.jsmc,
        xb: Number(global.$route.query.xb),
        zhmc: global.$route.query.zhmc,
        yhm: global.$route.query.yhm,
      }
      console.log(browserUrl)
      // 地址栏没有携带参数，点击退出登录进的login页
      if (!userInfo.zhid || !userInfo.yhid) {
        window.location.href = browserUrl
      } else {
        sessionStorage.setItem('yycdid', global.$route.query.yycdid)
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
        sessionStorage.setItem('token', decodeURIComponent(global.$route.query.token))
        global.$store.commit("setYycdid", Number(global.$route.query.yycdid))
        global.$store.commit("setInfo", userInfo)
        global.$store.commit("setToken", decodeURIComponent(global.$route.query.token))
        if (userInfo.jsmc == '家长') {
          setTimeout(() => {
            global.$router.replace({ name: 'parent' })
          }, 2000)
        } else {
          setTimeout(() => {
            global.$router.replace({ name: global.$route.query.jsmc === '学生' ? 'home' : 'myClass' })
          }, 2000)
        }
      }
    })
  },
}
</script>
<style lang="scss" scoped>
.login {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .main {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    img {
      animation-delay: 2s;
    }
    .text {
      color: #333;
      font-size: 32px;
      padding-top: 30px;
      animation-delay: 2s;
    }
  }
}
</style>